import ServiceBase from "base/baseService"

export default class FinalidadeOperacaoFiscalService extends ServiceBase {

    title = "Finalidade de operação"
    pluralTitle = "Finalidades de operações"
    url = '/cadastro/fiscal/finalidadeoperacaofiscal'
    frontUrl = '/cadastro/fiscal/finalidadeoperacaofiscal'
    frontUrlList = '/cadastro/fiscal/finalidadeoperacaofiscallist'
    primaryKey = 'codigo_fiof'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Se usar Switch (Se não permite null?)

        // Se usar checkbox (Se permite null?)

        // Numéricos com FK notNullable

        // Strings notNullable

        data.descricao_fiof = data?.descricao_fiof || ''

        // Numéricos sem FK

        // Dependentes

        // data.operacao_fiscal = data?.operacao_fiscal || [] // Isso não fez sentido em Serie

        // Datas

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
